var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root_buy_information"},[_c('v-col',{attrs:{"xl":"8","lg":"7","md":"6","sm":"5","xs":"12"}},[_c('BoxesProduct',{attrs:{"items":_vm.cart,"checkoutCart":_vm.checkoutCart}})],1),_c('v-col',{attrs:{"xl":"4","lg":"5","md":"6","sm":"7","xs":"12"}},[_c('SidBarInfo',{attrs:{"info":_vm.cart,"onClick":_vm.onClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }